import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardContent } from '@erp/ui';

/** Friendly placeholder shown when a user lacks the permission for the
 *  page they tried to open. Used by RequirePermission. */
export function NoAccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md items-center justify-center p-6">
      <Card className="w-full">
        <CardContent className="flex flex-col items-center gap-4 py-10 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <Lock className="h-7 w-7" aria-hidden />
          </div>
          <div className="space-y-1.5">
            <h2 className="text-lg font-semibold">
              {t('permissions.denied.title')}
            </h2>
            <p className="text-sm text-muted-foreground">
              {t('permissions.denied.message')}
            </p>
          </div>
          <Button variant="outline" onClick={() => navigate(-1)}>
            {t('permissions.denied.back')}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
